import { useRef } from "react";

import Row from "../row";
import List from "../list";
import { ButtonModify, ButtonRemove } from "../buttons";
import MediaHelper from '../../lib/helpers/media';
import meApi from "../../lib/users/me-api";
import Blurred from "../blurred";

export default function ProfileImage({ user, onChange }) {
    const ref = useRef(null);

    const handleChange = (e) => {
        let formData = new FormData();
        let file = e.target.files[0];

        formData.append("file", file, file.name);
        formData.append('path', '/users/me/profile-image');
        formData.append('params', JSON.stringify({}));

        meApi.uploadProfileImage(formData).then(onChange)
    }

    const upload = () => ref.current?.click();
    const remove = () => meApi.deleteProfileImage().then(onChange);

    const imageExists = user?.user_profile?.profile_img;

    return (
        <Row gap="20px" alignItems="center">
            <Blurred toggled={user?.user_profile?.profile_img === null}>
                <div className="profile-image" style={{
                    backgroundImage: `url('${imageExists ? MediaHelper.formatPrivatePath(`${user?.user_profile?.profile_img}`) : '/assets/user-icon.svg'}')`
                }}></div>
            </Blurred>
            <List gap="10px">
                <ButtonModify onClick={upload}>Upload</ButtonModify>
                { imageExists && <ButtonRemove onClick={remove}>Remove</ButtonRemove> }
                <input accept={'.jpeg, .jpg'} ref={ref} style={{ display : 'none' }} type={'file'} onChange={handleChange}/>
            </List>
        </Row>

    )
}
